import React from "react";
import IconTitleButton from "components/buttons/IconTitleButton";
import messages from "res/messages/farsi";
import {Divider} from "@material-ui/core";

export default function TitleHeader(props) {

    let header = props.header

    let titleColor = 'var(--gray_7)'
    if (header.titleColor) {
        titleColor = header.titleColor
    }

    function getClassName() {
        if (header.font_size_title === "1") {
            return "smallTextBold";
        } else if (header.font_size_title === "2") {
            return "mediumTextBold";
        } else if (header.font_size_title === "3") {
            return "largeTextBold";
        } else if (header.font_size_title === "4") {
            return "xLargeTextBold";
        } else if (header.font_size_title === "5") {
            return "xxLargeTextBold";
        } else if (header.font_size_title === "6") {
            return "xxxLargeTextBold";
        }
        return "largeTextBold";
    }

    return (
        <div style={{color: titleColor}}>
            <div className="horizontalFullScreen">
                <div className={getClassName()}
                     style={{width: "100%", textAlign: header.title_align ? header.title_align :'right', marginTop: "0.3em"}}>
                    {header.title}
                </div>
                <div style={{height: "2.5em"}}>
                    {header.on_more &&
                    <IconTitleButton
                        textcolor="var(--blue_5)"
                        onClick={() => {
                            props.onAllClicked()
                        }}
                        title={messages.seeAll}/>
                    }
                </div>
            </div>
            <div>
                <Divider/>
            </div>
        </div>
    )
}